// extracted by mini-css-extract-plugin
export default {"Details":"Details_Details__5-Q23","Left":"Details_Left__T6L41","Right":"Details_Right__Dzp8N","Main":"Details_Main__LOGy5","About":"Details_About__1n7Q8"};